export const upcomingEvents = [
  {
    id: 1,
    title: "微醺山林露營派對",
    subtitle: "星空、炭火與你的故事",
    category: "戶外冒險",
    categoryColor: "bg-orange-600",
    date: "2026/04/25 - 04/26",
    location: "南投縣仁愛鄉私房營地",
    spotsLeft: 8,
    totalSpots: 30,
    price: "NT$ 2,800",
    image: "https://public.readdy.ai/ai/img_res/29aab8541b44626e3d71f110713cbd2c.jpg",
    tags: ["露營", "烤肉", "星空電影"],
  },
  {
    id: 2,
    title: "靈魂交換讀書會",
    subtitle: "不只是閱讀，是一場知性派對",
    category: "知性學習",
    categoryColor: "bg-emerald-700",
    date: "2026/05/03",
    location: "台中市西區質感書房",
    spotsLeft: 5,
    totalSpots: 20,
    price: "NT$ 680",
    image: "https://readdy.ai/api/search-image?query=cozy%20book%20club%20gathering%20in%20warm%20lit%20cafe%2C%20people%20reading%20and%20discussing%20books%2C%20tea%20cups%20on%20wooden%20table%2C%20soft%20warm%20lighting%2C%20intellectual%20atmosphere%2C%20Taiwan%20lifestyle%20photography&width=600&height=800&seq=ev002&orientation=portrait",
    tags: ["讀書會", "深度對談", "輕食"],
  },
  {
    id: 3,
    title: "紅歡密聯誼賽",
    subtitle: "拒絕死板排排坐！趣味競賽找默契",
    category: "社交聯誼",
    categoryColor: "bg-rose-600",
    date: "2026/05/10",
    location: "台中市北區活動中心",
    spotsLeft: 15,
    totalSpots: 50,
    price: "NT$ 580",
    image: "https://readdy.ai/api/search-image?query=fun%20social%20gathering%20event%20with%20young%20adults%20playing%20games%2C%20laughing%20and%20interacting%2C%20colorful%20indoor%20venue%2C%20warm%20lighting%2C%20Taiwan%20social%20event%20photography%2C%20energetic%20atmosphere&width=600&height=800&seq=ev003&orientation=portrait",
    tags: ["聯誼", "趣味競賽", "破冰遊戲"],
  },
  {
    id: 4,
    title: "小小營火官親子營",
    subtitle: "昆蟲觀察、手作DIY、星空故事會",
    category: "親子時光",
    categoryColor: "bg-amber-600",
    date: "2026/05/17 - 05/18",
    location: "台中市和平區森林基地",
    spotsLeft: 10,
    totalSpots: 25,
    price: "NT$ 3,200",
    image: "https://readdy.ai/api/search-image?query=family%20camping%20with%20children%20in%20forest%2C%20parents%20and%20kids%20around%20campfire%2C%20daytime%20outdoor%20activities%2C%20nature%20exploration%2C%20warm%20sunlight%20through%20trees%2C%20Taiwan%20family%20outdoor%20event&width=600&height=800&seq=ev004&orientation=portrait",
    tags: ["親子", "自然探索", "手作DIY"],
  },
];

export const activityCategories = [
  {
    id: 1,
    icon: "ri-tent-line",
    title: "戶外冒險",
    description: "放下手機，走入自然。從奢華露營到荒野求生，讓炭火香氣與星光電影陪你找回生命的原始感動。",
    color: "bg-orange-50",
    accentColor: "text-orange-600",
    borderColor: "border-orange-200",
    count: 12,
  },
  {
    id: 2,
    icon: "ri-book-open-line",
    title: "知性學習",
    description: "腦力激盪，遇見更有趣的靈魂。沉浸式讀書會、跨界課程、劇本殺推演，讓思維在交流中無限延伸。",
    color: "bg-emerald-50",
    accentColor: "text-emerald-700",
    borderColor: "border-emerald-200",
    count: 8,
  },
  {
    id: 3,
    icon: "ri-group-line",
    title: "社交聯誼",
    description: "打破尷尬，創造自然的相遇。趣味競賽、破冰遊戲、實境闖關，讓好感在歡笑中自然萌芽。",
    color: "bg-rose-50",
    accentColor: "text-rose-600",
    borderColor: "border-rose-200",
    count: 15,
  },
  {
    id: 4,
    icon: "ri-heart-line",
    title: "親子時光",
    description: "血緣間最溫暖的連結。自然探索、手作DIY、親子露營，讓孩子在大自然中發現最真實的快樂。",
    color: "bg-amber-50",
    accentColor: "text-amber-600",
    borderColor: "border-amber-200",
    count: 6,
  },
];

export const memories = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=group%20of%20young%20adults%20around%20campfire%20at%20night%2C%20happy%20smiling%20faces%2C%20warm%20orange%20fire%20glow%2C%20forest%20camping%20Taiwan%2C%20candid%20photography%2C%20genuine%20joy%20and%20connection&width=800&height=560&seq=mem001&orientation=landscape",
    title: "部落露營",
    date: "2025/10",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=people%20laughing%20at%20book%20club%20discussion%2C%20cozy%20cafe%20setting%2C%20warm%20lighting%2C%20Taiwan%20lifestyle%2C%20intellectual%20gathering%2C%20genuine%20smiles&width=400&height=520&seq=mem002&orientation=portrait",
    title: "秋季讀書會",
    date: "2025/11",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=outdoor%20barbecue%20party%20with%20friends%2C%20grilling%20meat%2C%20laughing%20together%2C%20Taiwan%20outdoor%20gathering%2C%20warm%20afternoon%20light%2C%20social%20event&width=400&height=400&seq=mem003&orientation=squarish",
    title: "大蜥蜴烤肉派對",
    date: "2025/09",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=children%20and%20parents%20doing%20DIY%20craft%20activities%20outdoors%2C%20nature%20exploration%2C%20happy%20family%20moments%2C%20Taiwan%20family%20event%2C%20colorful%20handmade%20crafts&width=400&height=520&seq=mem004&orientation=portrait",
    title: "親子自然探索營",
    date: "2025/08",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=fun%20social%20mixer%20event%20with%20young%20adults%20playing%20team%20games%2C%20indoor%20venue%20with%20colorful%20decorations%2C%20Taiwan%20social%20gathering%2C%20energetic%20and%20joyful%20atmosphere&width=800&height=480&seq=mem005&orientation=landscape",
    title: "同濟會聯誼賽",
    date: "2025/07",
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=starry%20night%20sky%20above%20camping%20tents%20in%20Taiwan%20mountain%2C%20milky%20way%20visible%2C%20silhouettes%20of%20people%20watching%20stars%2C%20magical%20atmosphere%2C%20long%20exposure%20photography%2C%20warm%20amber%20tones&width=400&height=400&seq=mem006&orientation=squarish",
    title: "星空觀測夜",
    date: "2025/06",
  },
  {
    id: 7,
    image: "https://readdy.ai/api/search-image?query=young%20woman%20performing%20live%20singing%20on%20stage%20with%20microphone%2C%20spotlight%2C%20audience%20cheering%2C%20entertainment%20event%20Taiwan%2C%20vibrant%20energy%2C%20warm%20stage%20lighting&width=400&height=520&seq=mem007&orientation=portrait",
    title: "才藝之夜表演",
    date: "2025/05",
  },
  {
    id: 8,
    image: "https://readdy.ai/api/search-image?query=group%20hiking%20on%20mountain%20trail%20Taiwan%2C%20friends%20walking%20together%2C%20lush%20green%20forest%2C%20sunny%20day%2C%20adventure%20outdoor%20activity%2C%20candid%20happy%20moments%2C%20warm%20natural%20light&width=800&height=480&seq=mem008&orientation=landscape",
    title: "合歡山健行",
    date: "2025/04",
  },
  {
    id: 9,
    image: "https://readdy.ai/api/search-image?query=wine%20tasting%20social%20event%2C%20young%20adults%20holding%20wine%20glasses%2C%20elegant%20indoor%20setting%2C%20warm%20lighting%2C%20Taiwan%20lifestyle%20social%20gathering%2C%20smiling%20faces%2C%20cozy%20atmosphere&width=400&height=400&seq=mem009&orientation=squarish",
    title: "微醺品酒聯誼",
    date: "2025/03",
  },
  {
    id: 10,
    image: "https://readdy.ai/api/search-image?query=outdoor%20movie%20night%20under%20stars%2C%20projector%20screen%20in%20open%20field%2C%20people%20sitting%20on%20blankets%20and%20chairs%2C%20warm%20string%20lights%2C%20Taiwan%20glamping%20event%2C%20cozy%20romantic%20atmosphere&width=400&height=520&seq=mem010&orientation=portrait",
    title: "星空電影院",
    date: "2025/02",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "林小雨",
    role: "三次回訪會員 · 戶外冒險愛好者",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20young%20taiwanese%20woman%20smiling%20warmly%2C%20casual%20outdoor%20style%2C%20natural%20lighting%2C%20friendly%20expression%2C%20simple%20background&width=200&height=200&seq=ava001&orientation=squarish",
    content: "在紅歡密的露營活動中，我第一次感受到放下手機後的自在。營火旁的對話比任何社群媒體都真實，這是我今年最棒的決定。",
  },
  {
    id: 2,
    name: "陳建宏",
    role: "讀書會常客 · 斜槓創業者",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20young%20taiwanese%20man%20smiling%20confidently%2C%20casual%20smart%20style%2C%20natural%20lighting%2C%20approachable%20expression%2C%20simple%20background&width=200&height=200&seq=ava002&orientation=squarish",
    content: "讀書會讓我遇見了現在的創業夥伴！紅歡密不只是辦活動，他們真的在創造有意義的連結。",
  },
  {
    id: 3,
    name: "王美玲",
    role: "親子活動常客 · 兩個孩子的媽",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20taiwanese%20mother%20smiling%20warmly%2C%20casual%20family%20style%2C%20natural%20lighting%2C%20gentle%20expression%2C%20simple%20background&width=200&height=200&seq=ava003&orientation=squarish",
    content: "孩子在親子營認識了好朋友，我也交到了志同道合的媽媽們。紅歡密讓我們全家都找到了歸屬感。",
  },
];
